module.exports = __webpack_public_path__ + "static/media/effect-02.a8550004.png";